import Swiper from "swiper";
import { Navigation, Scrollbar, Pagination, Autoplay } from "swiper/modules";

Swiper.use([Navigation, Scrollbar, Pagination, Autoplay]);

let slidesOnDesktop = 3.5;
let slidesOnTablet = 3.5;
let slidesOnMobile = 2.2;

const initSlider = (slider) => {
  if (!(slider instanceof Element)) {
    console.error("Invalid slider element:", slider);
    return;
  }

  const id = slider.id;
  const numberOfSlides = $(slider).data("number-of-slides") || slidesOnDesktop;
  const numberOfSlidesOnTablet = $(slider).data("number-of-slides-tablet") || slidesOnTablet;
  const numberOfSlidesOnMobile = $(slider).data("number-of-slides-mobile") || slidesOnMobile;
  const sliderheight = $(slider).data("sliderheight") || "auto";
  const spaceBetween = $(slider).data("space-between");
  const sliderLoop = $(slider).data("loop") || false;
  const isAutoPlay = $(slider).data("autoplay") || false;
  const sliderPrev = slider.querySelector(`.swiper-navigation.swiper-button-prev[data-id="${id}"]`);
  const sliderNext = slider.querySelector(`.swiper-navigation.swiper-button-next[data-id="${id}"]`);
  const sliderPagination = slider.querySelector(`.swiper-pagination[data-id="${id}"]`);

  return new Swiper(slider, {
    slidesPerView: numberOfSlidesOnMobile,
    updateOnWindowResize: true,
    loop: sliderLoop,
    height: sliderheight,
    observer: true,
    observeParents: true,
    autoplay: isAutoPlay,
    spaceBetween: spaceBetween,
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev,
    },
    pagination: {
      el: sliderPagination,
      type: "bullets",
    },
    breakpoints: {
      768: {
        slidesPerView: numberOfSlidesOnTablet,
      },
      993: {
        slidesPerView: numberOfSlides,
      },
      1200: {
        slidesPerView: numberOfSlides,
      },
    },
  });
};

const initializeLightboxForSlider = (slider) => {
  const lightbox = slider.querySelector(".lightbox");
  const lightboxImage = lightbox.querySelector(".lightbox-image");
  let lightboxContent = lightbox.querySelector(".lightbox-slide-content");
  let lightboxCredits = lightbox.querySelector(".lightbox-slide-credits");

  if (!lightboxContent) {
    lightboxContent = document.createElement("div");
    lightboxContent.classList.add("lightbox-slide-content");
    lightbox.appendChild(lightboxContent);
  }

  if (!lightboxCredits) {
    lightboxCredits = document.createElement("div");
    lightboxCredits.classList.add("lightbox-slide-credits");
    lightbox.appendChild(lightboxCredits);
  }

  const closeButton = lightbox.querySelector(".lightbox-close");
  const images = slider.querySelectorAll(".swiper-slide img");

  images.forEach((image) => {
    image.addEventListener("click", function () {
      lightbox.classList.add("active");
      slider.classList.add("in-front");
      const nextFigurePopup = this.closest('figure').nextElementSibling;
      const nextImgPopup = nextFigurePopup ? nextFigurePopup.querySelector('img') : null;
      lightboxImage.src = nextImgPopup ? nextImgPopup.src : this.src;

      const parentSlide = this.closest(".swiper-slide");
      const slideContentAsset = parentSlide.querySelector(".slide-content-asset");
      const slideContentCredits = parentSlide.querySelector(".slide-content-credits");

      if (slideContentAsset) {
        lightboxContent.innerHTML = slideContentAsset.innerHTML;
        lightboxContent.style.display = "block";
      } else {
        lightboxContent.innerHTML = "";
        lightboxContent.style.display = "none";
      }

      if (slideContentCredits) {
        lightboxCredits.innerHTML = slideContentCredits.innerHTML;
        lightboxCredits.style.display = "block";
      } else {
        lightboxCredits.innerHTML = "";
        lightboxCredits.style.display = "none";
      }
    });
  });

  closeButton.addEventListener("click", function () {
    lightbox.classList.remove("active");
    slider.classList.remove("in-front");
    lightboxContent.innerHTML = "";
  });

  lightbox.addEventListener("click", function (event) {
    if (event.target === lightbox) {
      lightbox.classList.remove("active");
      slider.classList.remove("in-front");
      lightboxContent.innerHTML = "";
    }
  });
};

function initImageSlider() {
  const imageSliders = document.querySelectorAll(".js-image-slider");
  console.log("Found sliders:", imageSliders);

  if (imageSliders.length === 0) {
    console.warn("No sliders found with the class '.js-image-slider'.");
    return;
  }

  imageSliders.forEach((imageSlider) => {
    const lightboxCheck = imageSlider.querySelector(".lightbox");
    initSlider(imageSlider);

    /* Once all redesign done and if there is no use of lightbox, we can remove lightbox related logic from this file */
    if (lightboxCheck) {
        initializeLightboxForSlider(imageSlider);
    }
    
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initImageSlider();
});

export { initImageSlider };
